import { render, staticRenderFns } from "./host-set.vue?vue&type=template&id=04594b2c&scoped=true&"
import script from "./host-set.vue?vue&type=script&lang=js&"
export * from "./host-set.vue?vue&type=script&lang=js&"
import style0 from "./host-set.vue?vue&type=style&index=0&id=04594b2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04594b2c",
  null
  
)

export default component.exports